<template>
  <v-container
    fluid
    :style="{ backgroundColor: $vuetify.theme.current.colors.surface }"
    class="pa-0 mb-0 rounded-xl"
  >
    <v-card id="about" flat color="transparent" class="v-container">
      <v-row class="">
        <v-col
          cols="12"
          lg="6"
          xl="5"
          class="order-2 order-lg-1 d-flex justify-center align-center"
        >
          <div
            class="position-relative w-100 mb-10 mb-md-16 mb-lg-0 ml-lg-0 mr-lg-8"
          >
            <NuxtImg

              class="w-100 rounded-xl"
             src="/assets/home/4A.webp"
              alt=""
              sizes="100vw md:800px lg:800px xl:1000px"
              loading="lazy"
            />
            <!-- <NuxtImg
              sizes="200px sm:250px md:300px lg:350px xl:300px"
              class="position-absolute elevation-10 rounded-xl bouncing--horizontal"
              style="top: 0; right: 0; z-index: 10"
              src="/assets/graph_floating.webp"
              alt="Gráfico flotante de Truster Cloud"
              loading="lazy"
            />
            <NuxtImg
              sizes="200px sm:300px lg:250px xl:300px"
              class="position-absolute elevation-10 rounded-xl bouncing--vertical"
              style="left: 0; bottom: -32px; z-index: 10"
              src="/assets/hero_img_floating.webp"
              alt=""
              loading="lazy"
            /> -->
          </div>
        </v-col>
        <v-col cols="12" lg="6" xl="7" class="order-1 order-lg-2">
          <!-- <v-row class=""> -->
          <!-- <v-col cols="12"> -->
          <!-- <v-card-title class="text-h5 text-primary"
            >ABOUT OUR SAAS LANDING</v-card-title
          > -->
          <v-card-title class="text-h4 text-lg-h4"
            >El éxito de tu Negocio es nuestro Propósito</v-card-title
          >
          <!-- </v-col> -->
          <!-- <v-col cols="12"> -->
          <v-card-text
            class="py-0 text-h6 text-lg-h5 text-h6 text-medium-emphasis"
          >
            Nacimos del compromiso de llevar a las empresas al siguiente nivel.
            Entendimos los desafíos de la gestión, la falta de control y las
            horas perdidas. Por eso creamos Truster Cloud, una plataforma
            diseñada para automatizar, unificar y darte el control total que
            necesitas para crecer.
          </v-card-text>
          <!-- </v-col> -->
          <!-- <v-col
              cols="12"
              sm
              md="12"
              class="d-flex flex-column align-center text-center text-h6"
            > -->
          <v-card rounded="xl" class="my-4 pa-4 glass-card" width="100%">
            <v-row justify="space-between" class="ma-0">
              <v-col
                v-for="(feature, idx) in features"
                :key="idx"
                cols="12"
                sm="6"
                class="d-flex align-center text-start text-h6 text-xl-h5"
              >
                <v-icon
                  size="large"
                  class="mr-2"
                  color="primary"
                  :icon="feature.icon"
                />
                {{ feature.text }}
              </v-col>
            </v-row>
          </v-card>
          <v-row no-gutters justify="center" class="my-10">
            <v-btn
              color="primary"
              rounded="pill"
              :href="`mailto:${companyInfo.email}}`"
            >
              Contáctanos
            </v-btn>
            <v-btn
              color="primary"
              variant="plain"
              rounded="pill"
              class="ml-3 px-2"
              :href="`tel:${companyInfo.tel}}`"
            >
              <template #prepend>
                <v-chip avatar variant="tonal">
                  <v-icon size="24" color="primary" icon="$mdiPhone" />
                </v-chip>
              </template>
              <template #default>
                <div
                  class="d-flex flex-column text-caption text-black"
                  style="line-height: 1.3"
                >
                  Llámanos
                  <span class="font-weight-bold">
                    {{ companyInfo.tel }}
                  </span>
                </div>
              </template>
            </v-btn>
          </v-row>
          <!-- </v-col>
          </v-row> -->
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script setup lang="ts">
import companyInfo from "~/data/companyInfo";
const features = [
  {
    icon: "$mdiCheckDecagram",
    text: "Especialistas en metodologías y procesos ágiles",
  },
  {
    icon: "$mdiCheckDecagram",
    text: "Origen enfocado en el modelo de Cadena de Suministros",
  },
  {
    icon: "$mdiCheckDecagram",
    text: "Soluciones comprobadas en operaciones reales",
  },
  {
    icon: "$mdiCheckDecagram",
    text: "Trabajo colaborativo y transparente",
  },
];
// Responsive breakpoints
// const users = [
// 	{
// 		name: 'John Doe',
// 		email: 'john.doe@example.com',
// 		role: 'admin',
// 		created_at: '2022-01-01T00:00:00.000Z',
// 		updated_at: '2022-01-01T00:00:00.000Z',
// 		avatar: 'assets/home/team1.png',
// 		deleted_at: null,
// 		id: 1
// 	},
// 	{
// 		name: 'Jane Smith',
// 		email: 'jane.smith@example.com',
// 		role: 'user',
// 		created_at: '2022-01-02T00:00:00.000Z',
// 		updated_at: '2022-01-02T00:00:00.000Z',
// 		avatar: 'assets/home/team2.png',
// 		deleted_at: null,
// 		id: 2
// 	},
// 	{
// 		name: 'Bob Wilson',
// 		email: 'bob.wilson@example.com',
// 		role: 'user',
// 		created_at: '2022-01-03T00:00:00.000Z',
// 		updated_at: '2022-01-03T00:00:00.000Z',
// 		avatar: 'assets/home/team3.png',
// 		deleted_at: null,
// 		id: 3
// 	},
// 	{
// 		name: 'Alice Brown',
// 		email: 'alice.brown@example.com',
// 		role: 'user',
// 		created_at: '2022-01-04T00:00:00.000Z',
// 		updated_at: '2022-01-04T00:00:00.000Z',
// 		avatar: 'assets/home/team4.png',
// 		deleted_at: null,
// 		id: 4
// 	},
// 	{
// 		name: 'Charlie Davis',
// 		email: 'charlie.davis@example.com',
// 		role: 'user',
// 		created_at: '2022-01-05T00:00:00.000Z',
// 		updated_at: '2022-01-05T00:00:00.000Z',
// 		avatar: 'assets/home/team1.png',
// 		deleted_at: null,
// 		id: 5
// 	}
// ]
</script>

<style lang="scss" scoped>
.insight {
  padding: 12px 0;
}
.ceo_img {
  filter: drop-shadow(0.5rem 0.5rem 1rem rgba(0, 0, 0, 0.3));
}
.slide-text {
  padding-top: 0;
}
.bouncing--horizontal {
  animation: bounce-horizontal 4s ease-in-out infinite;
}
.bouncing--vertical {
  animation: bounce 4s ease-in-out infinite;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10%);
  }
}
@keyframes bounce-horizontal {
  0%,
  100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-10%);
  }
}
</style>
